import React, { useState } from "react";
import { Bot } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import VoiceBotModal from "./VoiceBotModal";

const FloatingButtons = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const whatsappNumber = "917259679676";

  return (
    <>
      {/* Floating Buttons */}
      <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-4">

        {/* AI Voice Bot */}

        <div className="group relative">

          <span className="absolute right-20 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition duration-300">
            Talk with AI HR Assistant
          </span>

          <button
            onClick={() => setIsModalOpen(true)}
            className="relative w-16 h-16 rounded-full bg-gradient-to-r from-[#FED547] to-yellow-400 shadow-2xl flex items-center justify-center hover:scale-110 transition duration-300"
          >
            {/* Pulse Animation */}

            <span className="absolute inline-flex h-full w-full rounded-full bg-[#FED547] opacity-40 animate-ping"></span>

            <Bot className="relative text-black" size={30} />
          </button>

        </div>

        {/* WhatsApp */}

        <div className="group relative">

          <span className="absolute right-20 top-1/2 -translate-y-1/2 whitespace-nowrap bg-black text-white text-sm px-3 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition duration-300">
            Chat on WhatsApp
          </span>

          <a
            href={`https://wa.me/${whatsappNumber}`}
            target="_blank"
            rel="noopener noreferrer"
            className="w-16 h-16 rounded-full bg-[#25D366] shadow-2xl flex items-center justify-center hover:scale-110 transition duration-300"
          >
            <FaWhatsapp
              size={34}
              className="text-white"
            />
          </a>

        </div>

      </div>

      {/* Voice Bot Modal */}

      <VoiceBotModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FloatingButtons;